let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dMbWq")).then(() => parcelRequire('8itfQ'));